import type {
  MyOrderLineFragment,
  ProductVariantLineFragment,
} from '@/graphql/saleor/api';

export type EngravingCardProductVariant = {
  checkoutLineId?: string;
  product:
    | ProductVariantLineFragment['product']
    | NonNullable<MyOrderLineFragment['variant']>['product'];
};

export type EngravingCardCheckoutProductVariant =
  EngravingCardProductVariant & {
    checkoutLineId: string;
  };

export function isEngravingCardCheckoutProductVariant(
  productVariant: EngravingCardProductVariant,
): productVariant is EngravingCardCheckoutProductVariant {
  return (
    'checkoutLineId' in productVariant &&
    typeof productVariant.checkoutLineId === 'string'
  );
}
